import { useEffect, useRef } from 'react';

interface ContextMenuItem {
  label: string;
  icon?: string;
  onClick: () => void;
  color?: string;
}

interface ContextMenuProps {
  x: number;
  y: number;
  items: ContextMenuItem[];
  onClose: () => void;
}

export default function ContextMenu({ x, y, items, onClose }: ContextMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      className="fixed bg-gray-800 rounded-lg shadow-lg border border-gray-700 py-1 z-50"
      style={{
        left: x,
        top: y,
        minWidth: '160px',
      }}
    >
      {items.map((item, index) => (
        <button
          key={index}
          className={`w-full px-4 py-2 text-left hover:bg-gray-700 flex items-center gap-2 ${
            item.color || 'text-gray-200'
          }`}
          onClick={() => {
            item.onClick();
            onClose();
          }}
        >
          {item.icon && <span>{item.icon}</span>}
          {item.label}
        </button>
      ))}
    </div>
  );
} 